import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const TableContext = createContext()

const TableProvider = ({ children }) => {

    const { headers, toast } = useAuth();

    const getAllTables = async (id) => {
        try {
            const { data } = await axios.get(`${baseURL}/table/list?Table_id=${id}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            console.log(error);
        }
    }

    const getSingleTable = async (id) => {
        try {
            let { data } = await axios.get(`${baseURL}/table/single-table/${id}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Table', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const createTable = async (tableDetail) => {
        try {
            const { data } = await axios.post(`${baseURL}/table/create`, tableDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Table', detail: data.message, life: 3000 })
                }, 500);
                return data;
            } else {
                toast.current?.show({ severity: 'error', summary: 'Table', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    toast.current?.show({ severity: 'error', summary: 'Table', detail: errors[0].msg, life: 3000 })
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Table', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const updateTable = async (id, tableDetail) => {
        try {
            const { data } = await axios.put(`${baseURL}/table/admin/update/${id}`, tableDetail, { headers });
            if(!data.error){
                return data;
            } else {
                toast.current?.show({ severity: 'error', summary: 'Table', detail: data?.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    toast.current?.show({ severity: 'error', summary: 'Table', detail: errors[0].msg, life: 3000 })
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Table', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const deleteTable = async (id) => {
        try {
            const { data } = await axios.delete(`${baseURL}/table/delete/${id}`, { headers });
            if (data.error === false) {
                toast.current.show({ severity: 'success', summary: 'Table', detail: data.message, life: 3000 })
            } else {
                toast.current?.show({ severity: 'error', summary: 'Table', detail: data.message, life: 3000 })
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Table', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    return (
        <TableContext.Provider value={{ getAllTables, getSingleTable, createTable, updateTable, deleteTable }}>
            {children}
        </TableContext.Provider>
    )
}

const useTable = () => useContext(TableContext)

export { useTable, TableProvider }